$(function(){
	$(".split-banner").each(function(){
        var bgcolor = $(this).data("background-color");
        $(this).css('backgroundColor', bgcolor);
    })
});

